import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

let shouldRemoveDossierNUmber = false;

export const DeclarationContainerGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const dossierSB = inject(DossierSandboxService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const dossierNumber = authService.getCurrentDossierId();
  if (!dossierNumber) {
    return of(true);
  } else {
    return authService.isAuthenticated$().pipe(
      switchMap((auth) => {
        if (auth) {
          return dossierSB.fetchDossier(dossierNumber).pipe(
            take(1),
            map(({ dossier }) => !!dossier),
            catchError((e) => {
              dossierSB.clearDossier();
              // Logout without loosing the dossierNUmber
              authService.logout();
              if (!shouldRemoveDossierNUmber) {
                // the first time don't remove the dossier Number.
                shouldRemoveDossierNUmber = true;
              } else {
                // if after a reconnect the same pb append then remove the dossier Number
                authService.clearCurrentDossierId();
                shouldRemoveDossierNUmber = false;
              }
              return of(router.parseUrl('/login'));
            })
          );
        } else {
          of(true);
        }
      })
    );
  }
};
